<template>
  <v-app-bar app color="primary">

    <v-app-bar-nav-icon class="hidden-sm-and-up"></v-app-bar-nav-icon>

    <v-toolbar-title class="text-sm-h4 text-h5" style="width: inherit;">
      <router-link to="/" class="text-decoration-none white--text">Hardin Computer Repair</router-link>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <v-toolbar-items class="hidden-xs-only">
      <v-btn text to="/">Home</v-btn>
      <v-btn text to="/total-care-service">Total Care Service</v-btn>
    </v-toolbar-items>

  </v-app-bar>
</template>


<script>
export default {
  name: 'ToolBar'
}
</script>